export function useAppSubdomain() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const windowRef = window;
  return Boolean(windowRef.Dashboard?.__container__?.use_app_subdomain);
}